var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('Navbar')],1),_c('router-view'),_c('div',{staticClass:"copy-right-style"},[_vm._v(" © COPYRIGHT 2021 AVILON ROBOTICS - ALL RIGHT RESERVED")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }